import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ClinicalTextTemplate } from '../../domain/models/clinical-text-template.model';
import { IClinicalTextTemplatesRepository } from '../../domain/repositories/clinical-text-templates.repository';
import { ClinicalTextTemplatesRemoteDatasource } from '../datasources/remote/clinical-text-templates.remote-datasource';
import { ClinicalTextTemplateMapper } from '../mappers/clinical-text-template.mapper';

@Injectable()
export class ClinicalTextTemplatesRepositoryImpl implements IClinicalTextTemplatesRepository {
  private readonly datasource = inject(ClinicalTextTemplatesRemoteDatasource);
  private readonly mapper = inject(ClinicalTextTemplateMapper);

  public getAll(): Observable<readonly ClinicalTextTemplate[]> {
    return this.datasource.getAll().pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toClinicalTextTemplate(dto))),
    );
  }
}
